import React, { useState, useEffect } from 'react';
import { Tabs } from 'components/shared/AntComponent';
import { Button, Input } from 'components/shared/FormComponent';
import { SearchOutlined } from 'components/shared/AntIcons';
import { CourseIcon, SubjIcon, DeptIcon, GroupIcon,SyllabusIcon } from 'assets/icons/CustomIcons';
import CourseList from './CourseList';
import SpecialisationMaster from './SpecialisationMaster';
import SubjectMaster from './SubjectMaster';
import GroupCategory from './GroupCategory';
import SyllabusMaster from './SyllabusMaster';

const ConfigurationScreen: React.FC = () => {
    const [activeTab, setActiveTab] = useState('1');

    const tabItems: any = [
        { key: '1', label: 'Specialization', children: <SpecialisationMaster />, icon: <DeptIcon size={19} /> },
        { key: '2', label: 'Subject', children: <SubjectMaster />, icon: <SubjIcon size={19} />, },
        { key: '3', label: 'Category', children: <GroupCategory />, icon: <GroupIcon size={18} /> },
        { key: "4", label: "Course", children: <CourseList />, icon: <CourseIcon size={16} /> },
        // { key: '5', label: 'Syllabus', children: <SyllabusMaster />, icon: <SyllabusIcon size={18}/>}
    ];

    const handleTabChange = (e: any) => {
        setActiveTab(e);
    }

    return (
        <div className='children-container my-3'>
            <div className="row m-0 page-header">
                <h5 className="col-md-3 text-start my-auto text-secondary fw-bold mb-2">Configuration</h5>
            </div>
            <div className='bg-white custom-tabs custom-table m-2 p-3 rounded'>
                <Tabs
                    defaultActiveKey={activeTab}
                    items={tabItems}
                    onChange={handleTabChange}
                />
            </div>
        </div>
    )
}

export default ConfigurationScreen;